import { render, staticRenderFns } from "./DepositDialog.vue?vue&type=template&id=06208493"
import script from "./DepositDialog.vue?vue&type=script&lang=js"
export * from "./DepositDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports